import socialApiAdapter from './social-api';
import socialMockAdapter from './__mocks__/social-api';
import mockMercuryApiAdapter from './__mocks__/mercury-api';
import mercuryApiAdapter from './mercury-api';

const isMock = Boolean(process.env.MOCK ?? false);

export const socialApi = isMock ? socialMockAdapter : socialApiAdapter;
export const mercuryApi = isMock ? mockMercuryApiAdapter : mercuryApiAdapter;
